var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"elevation":"0"}},[_c('v-card-title',{staticClass:"px-0 pt-2"},[_c('v-icon',{staticClass:"mr-2"},[_vm._v("mdi-book-open-outline")]),_vm._v(" 학습 코스 ")],1),_c('my-page-market-course-list')],1)}
var staticRenderFns = []

export { render, staticRenderFns }